export const TECHNICS = {
    martelo: { key: 'martelo', type: 'strike', point: 1, srcElement: 'martelo', strength: 1 },
    bencao: { key: 'bencao', type: 'strike', point: 2, srcElement: 'bensao', strength: 0.7 },
    rasteira: { key: 'rasteira', type: 'strike', point: 3, srcElement: 'negativa', strength: 0.7 },
    armada: { key: 'armada', type: 'strike', point: 1, srcElement: 'armada', strength: 0.8 },
    compassa: { key: 'compassa', type: 'strike', point: 1, srcElement: 'compassa', strength: 1.2, defences: [1] },
    pulada: { key: 'pulada', type: 'strike', point: 1, srcElement: 'pulada', strength: 1, defences: [3] },
    parafuso: { key: 'parafuso', type: 'strike', point: 1, srcElement: 'kick540', strength: 1.5, defences: [3] },

    combo3: { key: 'combo3', type: 'strike', point: 1, srcElement: 'compassa', strength: 2.5, defences: [1] },

    diagonale: { key: 'diagonale', type: 'defence', srcElement: 'diagonale', points: [1], noBuff: ['axe', 'uklon'] },
    middle1: { key: 'middle1', type: 'defence', srcElement: 'lateral', points: [2], noBuff: ['axe','uklon'] },
    jump: { key: 'jump', type: 'defence', srcElement: 'salforward', points: [3], noBuff: ['axe', 'uklon'] },

    beduin: { key: 'beduin', type: 'defence', srcElement: 'beduino', points: [1, 3], yesBuff: ['axe'] },
    salto: { key: 'salto', type: 'defence', srcElement: 'salback', points: [2, 3], yesBuff: ['axe'] },
    boche: { key: 'boche', type: 'defence', srcElement: 'baza', points: [1, 2], yesBuff: ['axe'] },

    
    goback: { key: 'goback', type: 'defence', srcElement: 'beduino', points: [1, 2, 3, 4], yesBuff: ['uklon'] },
}

export const BASE_STRIKES = ['martelo', 'bencao', 'rasteira'];

export const TECHNICS_SHIFT = {
    'strikepoint1': 'martelo',
    'martelo': 'armada',
    'armada': 'pulada',
    'pulada': 'compassa',
    'compassa': 'combo3',
    'combo3': 'parafuso',

    'strikepoint2': 'bencao',
    'bencao': 'chapa',
    'chapa': 'doubleleg',

    'strikepoint3': 'rasteira',
    'rasteira': 'rasteirabottom',
    'rasteirabottom': 'negativa',
}

/*
    allreadyStrikes: [martelo, bencao, rasteira, armada] - x размерность
    allStrikes: [...все ключи ударов]
    usedStrikeNumber от 0 до x, нпример = 0
*/
export const setStrikes = ({ allreadyStrikes = [], allStrikes, usedStrikeNumber }) => {

    const freeCards = allStrikes.reduce((memo, key) => {
        if (!allreadyStrikes.find(x => x === key)) return [...memo, key];
        return memo;
    }, [])
    if (allreadyStrikes[usedStrikeNumber])
        freeCards.push(allreadyStrikes[usedStrikeNumber])

    let lookedKey = allreadyStrikes[usedStrikeNumber];
    allreadyStrikes[usedStrikeNumber] = null;

    // если действие из первых трёх, то нам нужно поставить туда следующую карточку (если она есть)
    if (usedStrikeNumber < 3) {
        let findedKey = null;
        while (!findedKey) {
            lookedKey = TECHNICS_SHIFT[lookedKey];
            // должна быть проверка - а у нас вообще есть эта техника или нет, по идее смотрим это в freeCards
            if (!lookedKey) {
                lookedKey = `strikepoint${usedStrikeNumber + 1}`;
            }
            const findInFreeCard = freeCards.find(x => x === lookedKey);
            if (findInFreeCard) {
                findedKey = findInFreeCard;
                break;
            }
        }
        allreadyStrikes[usedStrikeNumber] = findedKey;
        return allreadyStrikes;
    }

    // если из доп. слотов, то мы берём любую свободную
    const findInFreeCardIndex = Math.floor((Math.random() - 0.0000005) * freeCards.length);
    allreadyStrikes[usedStrikeNumber] = freeCards[findInFreeCardIndex];
    return allreadyStrikes;
}